import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { OrderLifetimeRuleAction } from '@cbridge-packages/order-lifetime-rules';
import { RulesManagementAction, makeRuleRowModelAndState } from '@cbridge-modules/rules-management-page';

export const onLoadOrderLifetimeRulesDoneEpic: IEpic = (action$) => action$.pipe(
  isTypeOfAndGetPayload(
    OrderLifetimeRuleAction.loadList.done,
  ),
  mergeMap((payload) => {
    const { rows, initialState } = makeRuleRowModelAndState(payload.result);
    return [
      RulesManagementAction.updateState({ ...initialState, rules: rows }),
    ];
  }),
);
